export default "__VITE_ASSET__BKILXEmq__"